import React from 'react';
export const FeatureSwitch = ({ children, currentEnv, on }) => {
    return on.includes(currentEnv) ? React.createElement(React.Fragment, null, children) : null;
};
